export enum ECurrency {
  DKK = 'DKK',
  EUR = 'EUR',
  SEK = 'SEK'
}

export enum KPI_UNIT {
  SEK = 'kr',
  PERCENTAGE = '%'
}

export enum EDataMode {
  LOCKED = 'LOCKED',
  SYNCED = 'SYNCED'
}

export enum EPriority {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH'
}

export enum EPublicationStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export enum EAnalysisStatus {
  UNHANDLED = 'UNHANDLED',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED'
}

export enum EFortnoxTenantStatus {
  OK = 'OK',
  NEEDS_REAUTH = 'NEEDS_REAUTH',
  MISSING_LICENSE = 'MISSING_LICENSE'
}
